<template>
	<div class="slider-image">
		<div class="slider-image__image" :style="style"></div>
		<div v-if="$slots.overlay" class="slider__overlay-wrapper">
			<slot name="overlay" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: String,
		focalPoint: Object,
	},
	computed: {
		style() {
			return `backgroundImage: url(${this.value}); backgroundPosition: ${this.focalPoint.x * 100}% ${this.focalPoint.y *
				100}%;`
		},
	},
}
</script>
<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.slider-image {
	&__image {
		background-size: cover;
		background-color: grey;
		width: 100vw;
		height: inherit;
	}
}
</style>
